var giftTiers = [];

    
    

    
        giftTiers.push({
            'product': 'all-star-lax-t-shirt',
            'minimum': 100
        });
    

    
    

    
        giftTiers.push({
            'product': 'cash-money-bucket-hat',
            'minimum': 250
        });
    

    
    

    

    
    

    

    
    

    

    
    

    


( function($) {
    var currentTier = 0;

    window.checkGiftsStatus = function ( cart, _callback ) {
        $.get('/cart.js', function ( cart ) {

            var total = 0;
            var removals = [];
            var bundlePresent = false;

            // Let's get the real total (minus gifts) first.
            cart.items.forEach( function (item, key) {
                if ( !item.properties || typeof item.properties._is_gift === 'undefined' && typeof item.properties._tier_gift === 'undefined' ) {
                    total += item.line_price;
                }

                if ( item.properties && typeof item.properties._bundle_id !== 'undefined') {
                    bundlePresent = true;
                }
            });

            if ( bundlePresent ) {
                cleanUpGifts( cart );
                if ( typeof _callback === 'function') _callback(false);
                return;
            }


            // The second step is to get the current tier.
            currentTier = 0;
            giftTiers.forEach( function (tier, key) {
                if ( (parseFloat(tier.minimum) * 100) <= total ) {
                    currentTier = key + 1;
                }
            });

            $('.drawer__gift').each( function () {
                var $gift = $(this);
                var tier = $gift.data('tier');

                if ( tier <= currentTier ) {
                    $gift.addClass('unlocked');
                } else {
                    $gift.removeClass('unlocked');
                    if ( $gift.hasClass('added') ) {
                        $gift.removeClass('added');
                        removals.push( $gift.data('variant-id') );
                    }

                    var minimum = $gift.data('minimum');
                    $gift.find('.drawer__gift__minimum').text('$' + ((minimum - total) / 100.0).toFixed(2) );
                }
            });

            // If there are no removals, we just don't do anything else.
            if ( removals.length < 1 ) {
                if ( typeof _callback === 'function' ) {
                    _callback( false );
                }
                return;
            }

            var quantities = [];
            cart.items.forEach( function (item) {
                if ( item.properties && item.properties._is_gift && removals.indexOf( item.variant_id ) > -1 ) {
                    quantities.push(0);
                } else {
                    quantities.push( item.quantity );
                }
            });

            // We remove items that fell below the tier.
            $.post('/cart/update.js', { updates: quantities}, function (cart) {
                if ( typeof _callback !== 'undefined' ) { _callback( true ); }
            }, 'json');
        }, 'json');
    }


    /*
     * Adding a single varinat gift to cart.
     */
    $('.drawer__gift [data-add]').on('click', function () {
        addGiftToCart( $(this).closest('.drawer__gift') );
    });


    /**
     * Opening the variants selector
     */
    $('.drawer__gift [data-select]').on('click', function () {
        $(this).parent().find('.drawer__gift__variants').addClass('active');
    });

    $('.drawer__gift .drawer__gift__image').on('click', function() {
        $(this).parent().find('.drawer__gift__variants').addClass('active');
    });


    /**
     * Removing an item from cart.
     */
    $('.drawer__gift [data-remove]').on('click', function () {
        var $gift = $(this).closest('.drawer__gift');
        var id = $gift.data('variant-id');

        $.get('/cart.js', function (cart) {
            var line = null;
            cart.items.forEach( function(item, key) {
                if ( item.properties && item.properties._is_gift && item.variant_id == id ) {
                    line = key + 1;
                    return false;
                }
            });

            if ( line ) {
                $.post('/cart/change.js', { line: line, quantity: 0 }, function (cart) {
                    $gift.closest('.drawer__gift').removeClass('added');
                    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                        bubbles: true
                    }));
                }, 'json');
            }
        }, 'json');
    });

    $('.drawer__gift__variant').on('click', function () {
        var id = $(this).data('variant-id');
        var $gift = $(this).closest('.drawer__gift');
        $(this).closest('.drawer__gift__variants').removeClass('active');
        $gift.data('variant-id', id );
        addGiftToCart( $gift );
    });

    function addGiftToCart( $gift ) {

        if ( $('.drawer__gift.added').length >= 1 ) {
            alert("Remove your current gift before adding another one.");
            return;
        }

        $.post('/cart/add.js', {
            id: $gift.data('variant-id'),
            quantity: 1,
            properties: { _is_gift: 1 }
        }, function (response) {
            $gift.addClass('added');
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                bubbles: true
            }));
        }, 'json');
    }

    function cleanUpGifts( cart, _callback ) {
        $('.drawer__gift').removeClass('added')
            .removeClass('unlocked');

        var quantities = [];
        cart.items.forEach( function (item) {
            if ( item.properties && item.properties._is_gift ) {
                quantities.push(0);
            } else {
                quantities.push( item.quantity );
            }
        });

        // We remove items that fell below the tier.
        $.post('/cart/update.js', { updates: quantities }, function (cart) {
            if ( typeof _callback !== 'undefined' ) { _callback( true ); }
        }, 'json');
    }

    window.checkGiftsStatus();
} (jQuery));


/**
 * Tiered gifts Behavior.
 */
(function ($) {

    let productbundle = [
        'og-winter-hat-1', 'hooded-sweatshirt', 'og-fleece-joggers',
        'crew-socks-3-pack', 'og-zip-up-hooded-sweatshirt',
        'big-goat-crewneck-1', 'freedom-winter-hat', 'freedom-hooded-sweatshirt',
        'freedom-lst', 'freedom-zip-up-sweatshirt', 'og-lst-1'
    ];

    var settings = {
        enabled: false,
        enabledDiscountOnly: false,
        tiers: [
            {
                minimum: 1,
                variants: ''.split(',')
            },
            {
                minimum: 150,
                variants: ''.split(',')
            },
            {
                minimum: 250,
                variants: ''.split(',')
            }
        ]
    };

    window.checkGiftsTiers = function( parentCart, updateCart) {
        var deferred = $.Deferred();
        var updateCart = updateCart || true;
        disableCheckoutButtons(true);

        if( !settings.enabled && !settings.enabledDiscountOnly) {
            deferred.resolve(false);
            disableCheckoutButtons(false);
            return deferred.promise();
        }

        if(settings.enabledDiscountOnly){
            getCart(parentCart).then( function(cart) {
                var subtotal = 0;
                var cartTier = null;
                var bundlePresent = false;
                cart.items.forEach( function(item) {
                    if ( item.properties._is_gift == null
                        && item.properties._tier_gift == null
                        && item.properties._bundle_id == null
                    ) {
                        subtotal += item.original_line_price;
                    } else {
                        cartTier = parseInt(item.properties._tier);
                        //if ( item.properties._bundle_id != null ) {
                        //    bundlePresent = true;
                        //}
                    }
                });

                // Now let's get the current tier. If the subtotal is greater than zero,
                // then that means there are non gift items in cart, so we check.
                // If there are bundles present. then we just skip this and the tier is zero.
                var currentTier = 0;
                if ( subtotal > 0) {
                    settings.tiers.forEach( function (tier) {
                        if ( tier.minimum * 100 > subtotal ) return false;
                        currentTier++;
                    });
                }

                if( currentTier > 0 ) {
                    var lineItems = [];
                    cart.items.forEach( function(item, i) {
                        if ( item.properties._bundle_id == undefined ) {
                            lineItems.push(
                                {
                                    line: i + 1,
                                    quantity: item.quantity,
                                    properties: {
                                        ...item.properties, // Keeping the original properties.
                                        _tier: currentTier
                                    }
                                }
                            );
                        }
                    });
                    if(lineItems.length > 0){
                        updateProperties(0, lineItems)
                        disableCheckoutButtons(false);
                        deferred.resolve( true );
                    }
                }

                 disableCheckoutButtons(false);
                 deferred.resolve( true );
            });
        } else {
            getCart(parentCart).then( function(cart) {
                var subtotal = 0;
                var cartTier = null;
                var bundlePresent = false;
                cart.items.forEach( function(item) {
                    if ( item.properties._is_gift == null
                        && item.properties._tier_gift == null
                        && item.properties._bundle_id == null
                    ) {
                        subtotal += item.original_line_price;
                    } else {
                        cartTier = parseInt(item.properties._tier);
                        if ( item.properties._bundle_id != null ) {
                            bundlePresent = true;
                        }
                    }
                });

                // Now let's get the current tier. If the subtotal is greater than zero,
                // then that means there are non gift items in cart, so we check.
                // If there are bundles present. then we just skip this and the tier is zero.
                var currentTier = 0;
                if ( subtotal > 0 && !bundlePresent ) {
                    settings.tiers.forEach( function (tier) {
                        if ( tier.minimum * 100 > subtotal ) return false;
                        currentTier++;
                    });
                }

                // If the tier attribute exists and it is the same than the current one, we just
                // skip the process.
                if ( cartTier && cartTier == currentTier || !cartTier && subtotal === 0 || !cartTier && bundlePresent ) {
                    deferred.resolve(false);
                    disableCheckoutButtons(false);
                    return;
                }

                // Otherwise, we update.
                var quantities = [];
                cart.items.forEach( function(item) {
                    quantities.push( (item.properties._tier_gift != null) ? 0 : item.quantity );
                });

                $.post('/cart/update.js', { updates: quantities }, function ( clearResponse ) {
                    if( currentTier > 0 ) {
                        var items = settings.tiers[ currentTier - 1 ].variants.map( function (v) {
                            return {
                                id: v,
                                quantity: 1,
                                properties: {
                                    _tier: currentTier,
                                    _tier_gift: true
                                }
                            };
                        });
                        $.post('/cart/add.js', {items: items}, function( addResponse ) {
                            if ( updateCart ) refreshCart();
                            disableCheckoutButtons(false);
                            deferred.resolve( true );
                        }, 'json');
                    } else {
                        if ( updateCart ) refreshCart();
                        disableCheckoutButtons(false);
                        deferred.resolve( true );
                    }
                }, 'json');
            });
        }
        return deferred.promise();
    }


    function updateProperties(index, line_items){
       var deferred = $.Deferred();
       $.post('/cart/change.js', line_items[index], function ( response ) {
            index++;
            if(line_items.length > index){
                updateProperties(index, line_items);
            }
            disableCheckoutButtons(false);
            deferred.resolve( true );
            if($("#CartDrawer").hasClass('drawer--is-open')){
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    bubbles: true
                }));
            }
        }, 'json');
    }

    /**
     * Wraps the cart object to use the existing, or to pull a new one
     * if the existing cart is not an object.
     * @param cart
     */
    function getCart(cart) {
        var deferred = $.Deferred();

        if ( typeof cart === 'object' && cart != null ) {
            deferred.resolve( cart );
        } else {
            $.get('/cart.js', function (cart) {
                deferred.resolve( cart );
            }, 'json');
        }

        return deferred.promise();
    }

    /**
     * Refreshes the cart page, or rebuilds the drawer,
     * depending on which page the customer is.
     */
    function refreshCart() {
        var location = window.location.pathname;
        if ( location == '/cart' || location.indexOf('/checkouts/') > -1) {
            window.location.reload();
        } else {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                bubbles: true
            }));
        }
    }


    function disableCheckoutButtons(boolean) {
        $('.fake__cart__checkout__button').toggleClass('disabled', boolean);
        $('[name=checkout]').prop('disabled', boolean);
    }

    window.checkGiftsTiers();
} (jQuery));
